<template>
	<div class="user_wrap">
		<div class="top_header">
			<div class="red_top_bg">
				<div class="big_tit" style="display: none;">
					{{ $t('home.my') }}
				</div>
				<div class="sign" @click="$router.push('/sign')">
					<img src="../images/user/sign.png">
				</div>
			</div>
			<div class="user_detail">
				<div class="user_header">
					<!-- <img :src="data.user_icon" alt=""> -->
					<img src="../images/user/11wh0-eeva3.png" alt="国徽" />
				</div>
				<div class="user_name">
					<div class="user_all">
						<p class="user_nickname">
							{{ data.name ? data.name : data.mobile }}
						</p>
					</div>
				</div>
			</div>
			<div class="user_vip">
				<div class="vip-box">
					邀请码:{{ data.invitation_code }}
					<!-- <div class="vip-badge" />邀请码:{{ data.invitation_code }} -->
				</div>
				<!-- <p>{{$t('user.welcome')}}</p> -->
			</div>
		</div>
		<div class="card balance-card">
			<div class="money-bottom">
				<div>
					账号余额
					<van-icon name="eye-o" @click="eye = !eye" />
				</div>
				<div class="money-right">
					<!-- <span @click="$router.push('/invest')">明细</span> -->
					<span @click="$router.push('/moneybag')">明细</span>
					<span @click.stop="withdraw">提现</span>
				</div>
			</div>
			<div class="money-contain">
				<div style="font-size: 20px;">￥{{ eye == 1 ? data.balance : "******" }}</div>
				<span v-if="data.liftLimit_switch == 1" @click="$router.push('/moneyAuth')">汇款认证</span>
			</div>
		</div>
		<div style="height: 40px;"></div>
		<div v-if="data.withdrawal_big_switch == 1" class="box bank-card" @click="paymentBig">
			<!-- <div class="freez-card">解冻银行卡</div>
			<div class="fajia">帮你发家致富</div> -->
		</div>
		<div v-if="data.invite_activation_switch == 1" class="box invite-card" @click="$router.push('/inviteNew')">
			<div class="freez-card">邀请好友</div>
			<div class="fajia">让你开心领大奖！</div>
		</div>
		<div v-if="data.onlineBank_switch == 1" class="box onlineBank-card" @click="getOnlineBank">
			<div class="freez-card">开通网银</div>
			<div class="fajia">实时汇款到账</div>
		</div>
		<!-- 纳税 -->
		<div v-if="data.paytaxes_switch == 1" class="box payTaxes-card" @click="getPayTaxes">
		</div>
		<div class="card-icon">
			<div class="icon-item" @click="$router.push('/myTeam')">
				<img src="../images/user/terms.jpg" alt="">
				<span class="custom-icon">我的团队</span>
			</div>
			<div class="icon-item" @click="$router.push('/reward')">
				<img src="../images/user/termqifei.jpg" alt="">
				<span class="custom-icon">团队奖励</span>
			</div>
			<div class="icon-item" @click="goAuth">
				<img src="../images/user/realname.jpg" alt="">
				<span class="custom-icon">实名认证</span>
			</div>
			<div class="icon-item" @click="$router.push('/account')">
				<img src="../images/user/renzhen.jpg" alt="">
				<span class="custom-icon" style="white-space: nowrap;">银行卡绑定</span>
			</div>

		</div>
		<div class="user_block">
			<div v-if="eye == 1" class="user_grid clear">
				<div class="user_grid__item">
					<div class="user_grid__card user_money">
						<p>{{ $t('user.uncollectedPrincipal') }}</p>
						<p>{{ data.wait_money }}</p>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_money">
						<p>{{ $t('user.uncollectedInterest') }}</p>
						<p>{{ data.wait_lixi }}</p>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_money">
						<p>{{ $t('user.cumulativeIncome') }}</p>
						<p>{{ data.all_lixi }}</p>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_balance">
						<div>
							{{ $t('user.totalBalance') }}
							<van-icon name="eye-o" @click="eye = 0" />
						</div>
						<div>
							{{ data.all_money }}
						</div>
					</div>
				</div>
			</div>
			<div v-if="eye == 0" class="user_grid clear">
				<div class="user_grid__item">
					<div class="user_grid__card user_money">
						<p>{{ $t('user.uncollectedPrincipal') }}</p>
						<p>******</p>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_money">
						<p>{{ $t('user.uncollectedInterest') }}</p>
						<p>******</p>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_money">
						<p>{{ $t('user.cumulativeIncome') }}</p>
						<p>******</p>
					</div>
				</div>
				<div class="user_grid__item">
					<div class="user_grid__card user_balance">
						<div>
							{{ $t('user.totalBalance') }}
							<van-icon name="closed-eye" @click="eye = 1" />
						</div>
						<div>
							******
						</div>
					</div>
				</div>
			</div>
			<div class="user_kf" @click="$router.push('/kefu')">
				<img src="../images/user/kf.png" alt="">
				<p>{{ $t('user.onlineService') }}</p>
			</div>
		</div>
		<!-- <div class="user_yw">
			<div @click="$router.push('/order')">
				<img src="../images/user/order.png" alt="" />
				<p>{{$t('user.myInvestment')}}</p>
			</div>
			<div @click="$router.push('/moneybag')">
				<img src="../images/user/details.png" alt="" />
				<p>{{$t('user.transactionDetails')}}</p>
			</div>
			<div @click="$router.push('/kefu')">
				<img src="../images/user/kf.png" alt="" />
				<p>{{$t('user.onlineService')}}</p>
			</div>
		</div> -->
		<div class="money" style="display: none;">
			<div class="money-hd">
				<p>{{ $t('user.availableBalance') }}</p>
				<!--<p><span style="color: black;">{{$t('utils.moneyMark')}}</span>:{{data.money}}</p>-->
				<p>{{ data.money }}</p>
			</div>
			<div class="money-bd">
				<span @click="$router.push('/invest')">{{ $t('user.recharge') }}</span>
				<span @click="$router.push('/cash')">{{ $t('user.withdraw') }}</span>
			</div>
		</div>
		<div class="list" style="margin: 20px;">
			<van-cell is-link @click="$router.push('/address')">
				<template #title>
					<img src="../images/user/moneybag.png" alt="">
					<span class="custom-title">收货地址</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/openChat')">
				<template #title>
					<img src="../images/user/team.png" alt="">
					<span class="custom-title">官方群聊</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/moneybag')">
				<template #title>
					<img src="../images/user/tx.png" alt="">
					<span class="custom-title">资金明细</span>
				</template>
			</van-cell>
			<van-cell is-link @click.stop="openChat">
				<template #title>
					<img src="../images/user/kf.png" alt="">
					<span class="custom-title">在线客服</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/benefit')">
				<template #title>
					<img src="../images/user/yq.png" alt="">
					<span class="custom-title">报备名额</span>
				</template>
			</van-cell>

			<!-- <van-cell is-link @click="$router.push('/unbindBankCard')"> -->
			<van-cell is-link @click="$router.push('/fiveStars')" v-if="data.fivestars_switch == 1">
				<template #title>
					<img src="../images/user/badge.png" alt="">
					<span class="custom-title">VIP会员</span>
				</template>
			</van-cell>

			<!-- <van-cell is-link @click="$router.push('/unbindBankCard')"> -->
			<van-cell is-link @click="getThawCard">
				<template #title>
					<img src="../images/user/recharge4.png" alt="">
					<span class="custom-title">解冻银行卡</span>
				</template>
			</van-cell>

			<!-- <van-cell is-link @click="$router.push('/loseRecovery')"> -->
			<van-cell is-link @click="getFundsRecovery">
				<template #title>
					<img src="../images/user/cz.png" alt="">
					<span class="custom-title">亏损资金追回</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/receive')">
				<template #title>
					<img src="../images/user/recharge4.png" alt="">
					<span class="custom-title">领取支票</span>
				</template>
			</van-cell>
			<van-cell is-link @click="$router.push('/safe')">
				<template #title>
					<img src="../images/user/setting.png" alt="">
					<span class="custom-title">账号管理</span>
				</template>
			</van-cell>
		</div>

		<div class="flex_center" @click="logout">
			<span>{{ $t('safe.signOut') }}</span>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import qs from 'qs';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index";
	import {
		Icon,
		Cell,
		CellGroup
	} from "vant";

	Vue.use(Cell).use(CellGroup).use(Icon);

	export default {
		name: "User",
		components: {},
		data() {
			return {
				data: {},
				bankdata: {},
				eye: 1,
				checked: true,
			};
		},
		created() {
			this.$parent.footer('user');
		},
		mounted() {
			this.start();
			this.banksum();
		},
		methods: {
			openChat() {
				Fetch('/user/system_info').then((r) => {
					window.location.href = r.data.service
					// window.open(r.data.service, '_blank');
				});
			},
			goAuth() {
				if (this.data.is_auth == 1) {
					this.$toast({
						className: "toastName",
						message: '已实名',
					});
				} else {
					this.$router.push('/authEmail')
				}

			},
			logout() {
				localStorage.removeItem('token');
				this.$router.replace("/");
			},
			start() {
				Fetch('/user/info').then((r) => {
					this.data = r.data;
				});
			},
			banksum() {
				Fetch('/user/my_bank').then(r => {
					this.bankdata = r.data;
					// this.allNum = r.data.count;
				})
			},
			withdraw() {
				if (this.bankdata.count == 0) {
					this.$router.push('/account')
				}
				if (this.data.payment == 0) {
					this.$router.push('/losePage')
				}
				if (this.data.payment == 1 && this.data.is_big_payment == 0) {
					this.$router.push('/withdraw')
				}
				if (this.data.is_big_payment == 1) {
					this.$router.push('/withdrawBig')
				}
			},
			paymentBig() {
				if (this.data.is_big_payment == 1) {
					this.$toast({
						className: "toastName",
						message: '已开通大额提现钱包',
					});
				} else {
					this.$router.push('/paymentBig')
				}
			},
			// inviteNew() {
			// 		this.$router.push('/inviteNew')
			// },
			getThawCard() {
				if (this.data.thaw_switch != 1) {
					this.$router.push('/unbindBankCard')
				} else if (this.data.thaw_switch == 1 && this.data.is_thaw_bankcard != 1) {
					this.getPayment(4);
				} else {
					this.$toast({
						className: "toastName",
						message: '银行卡已解冻成功',
					});
				}
			},
			getFundsRecovery() {
				if (this.data.recover_switch != 1) {
					this.$router.push('/loseRecovery')
				} else if (this.data.recover_switch == 1 && this.data.is_funds_recovery != 1) {
					this.getPayment(5);
				} else {
					this.$toast({
						className: "toastName",
						message: '亏损资金已追回成功',
					});
				}
			},
			getPayTaxes() {
				if (this.data.is_pay_taxes != 1) {
					this.getPayment(6);
				} else {
					this.$toast({
						className: "toastName",
						message: '个人所得税已缴纳',
					});
				}
			},
			getOnlineBank() {
				if (this.data.is_online_bank != 1) {
					this.$router.push('/onlineBank');
				} else {
					this.$router.push('/onlineBankDetails');
				}
			},
			getPayment(type) {
				this.$router.push({
					path: '/payment',
					query: {
						type: type
					}
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		//display: none;
		position: absolute;
		background: unset;

		.sign {
			position: absolute;
			top: 15px;
			right: 15px;
			height: 30px;

			img {
				height: 100%;
			}
		}
	}


	.user_block {
		margin-top: 10px;
		padding: 10px 15px;
		display: none;

		.user_kf {
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 5px;
			background: #cb2310;
			// background-image: linear-gradient(to right, #ff5252, #ff8244);
			box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
			color: #fff;
			font-size: 12px;
			padding: 10px;

			img {
				width: 27px;
				height: 27px;
				margin-right: 8px;
			}
		}

		.user_grid {
			margin: 0 -7.5px;

			.user_grid__item {
				float: left;
				width: 50%;
				padding: 0 7.5px;
				box-sizing: border-box;

				.user_grid__card {
					border: 1px solid #eeeeee;
					background-color: #fff;
					border-radius: 5px;
					box-shadow: 2px 2px 5px rgba(115, 115, 115, 0.35);
					margin-bottom: 10px;
					text-align: center;
					padding: 12px;
				}

				.user_money {
					p:nth-child(1) {
						font-size: 12px;
						color: #999992;
					}

					p:nth-child(2) {
						font-size: 12px;
						color: #ef5040;
						margin-top: 8px;
					}
				}

				.user_balance {
					div:nth-child(1) {
						font-size: 12px;
						color: #999992;
					}

					div:nth-child(2) {
						font-size: 12px;
						color: #ef5040;
						margin-top: 8px;
					}
				}
			}
		}
	}


	.user_wrap {
		position: relative;
		max-width: 100%;
		overflow: hidden;
		padding-bottom: 60px;
		background-color: #fff;
	}

	.top_header {
		position: relative;
		width: 100%;
		height: 250px;
		background-image: url(../images/user/imagesred3.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 142% 150%;

		.user_detail {
			width: 100%;
			padding: 58px 15px 0;

			.user_header {
				width: 70px;
				height: 70px;
				overflow: hidden;
				margin: 0 auto;
				border-radius: 50%;

				img {
					width: 100%;
					height: 100%;
					// border: 2px solid #FFFFFF;
					border-radius: 30px;
				}
			}

			.user_name {
				margin-top: 5px;
				color: #FFFFFF;
				text-align: center;

				.user_all {

					.user_nickname {
						line-height: 22px;
						font-size: 15px;
						font-weight: bold;
					}
				}
			}
		}

		.user_vip {
			color: #FFFFFF;
			text-align: center;
			padding: 8px 15px;

			.vip-box {
				position: relative;
				text-align: center;
				font-size: 12px;
				min-width: 45px;
				padding: 0 14px;
				line-height: 15px;
				border-radius: 8px;
				display: inline-block;
				// background-image: linear-gradient(to right, #ffa51e, #ffe462);

				.vip-badge {
					position: absolute;
					left: -8px;
					top: -2.5px;
					width: 20px;
					height: 20px;
					background-image: url(../images/user/badge.png);
					background-position: center;
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}
			}
		}

		.user_balance {
			text-align: center;

			div {
				margin: 10px 0;
			}

			div:nth-child(1) {
				font-size: 14px;
				color: #d3d5d6;
			}

			div:nth-child(2) {
				font-weight: bold;
				font-size: 18px;
				color: #FFFFFF;
			}
		}

		.user_money {
			display: flex;
			justify-content: space-between;
			text-align: center;

			p {
				margin: 10px 0;
			}

			div {
				width: 33.33%;
			}

			p:nth-child(1) {
				font-size: 14px;
				color: #d3d5d6;
			}

			p:nth-child(2) {
				font-size: 14px;
				color: #FFFFFF;
			}
		}
	}

	.kong {
		width: 100%;
		height: 35px;
		background: #FFFFFF;
	}

	.user_yw {
		display: flex;
		justify-content: space-between;
		text-align: center;
		width: 96%;
		position: relative;
		// top: -83px;
		background: #FFFFFF;
		left: 2%;
		border-radius: 5px 5px 0 0;
		padding: 15px 0;

		div {
			width: 33.33%;
		}

		p {
			margin-top: 8px;
		}

		img {
			width: 30px;
			height: 30px;
		}
	}

	.money {
		background: #FFFFFF;
		padding: 15px 15px 20px;
		border-bottom: 1px solid #eeeeee;
		border-top: 1px solid #eeeeee;

		.money-hd {
			text-align: center;

			p:nth-child(1) {
				color: #999;
				margin-bottom: 10px;
			}

			p:nth-child(2) {
				font-size: 14px;
				color: #ff5252;
				font-weight: bold;
			}
		}

		.money-bd {
			text-align: center;
			margin-top: 13px;

			span {
				padding: 3.5px 7px;
				border-radius: 5px;
				margin: 0 8px;
				width: 124px;
				line-height: 2;
				font-size: 14px;
				display: inline-block;
				color: #FFFFFF;
			}

			span:nth-child(1) {
				background: #ff5451;
			}

			span:nth-child(2) {
				background: #04c382;
			}
		}
	}

	.list {
		margin-top: 10px;

		.van-cell {
			padding: 8px 15px;
			margin-bottom: 5px;
			border: 1px solid rgb(222, 219, 219);
			border-radius: 5px;

			.van-cell__title {
				display: flex;
				align-items: center;
				color: #333333;
				font-size: 12px;

				img {
					height: 17px;
					width: 17px;
					margin-right: 6px;
					vertical-align: middle;
				}
			}
		}

		.van-cell::after {
			left: 0;
			right: 0;
			border-bottom: 1px solid #ebe9e9;
		}
	}

	.card {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
		width: 330px;
		// background: #fff;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
		padding: 15px;
		box-sizing: border-box;
	}

	.box {
		width: 330px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
		border-radius: 8px;
		padding: 15px;
		box-sizing: border-box;
		margin: 15px auto 0;
		height: 60px;
		background-size: 100%;
		background-position: center;
		background-repeat: no-repeat;
	}

	.balance-card {
		z-index: 10;
		color: #fff;
		top: 210px;
		height: 80px;
		background-image: url(../images/user/556699.jpg);
		background-size: 112% 132%;
		background-position: center;
		background-repeat: no-repeat;
		// background-color: #cb2310;
	}

	.bank-card {
		background-image: url(../images/user/withdrawal_wallet.png);
	}

	.invite-card {
		background-image: url(../images/user/invite.png);
	}

	.onlineBank-card {
		background-image: url(../images/user/onlineBank.jpg);
	}

	.payTaxes-card {
		background-size: 138%;
		background-image: url(../images/user/payTaxes.png);
	}

	.money-contain {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 10px;

		span {
			width: 60px;
			display: inline-block;
			// background: #000;
			/* line-height: 2; */
			height: 20px;
			text-align: center;
			line-height: 18px;
			border-radius: 10px;
			font-size: 12px;
			// color: #FFFFFF;
			border: 1px solid #fff;
			// height: 20px;
			background: #cb2310;
			color: #FFFFFF;
		}
	}

	.money-bottom {
		display: flex;
		justify-content: space-between;

		span {
			width: 58px;
			display: inline-block;
			// background: #000;
			/* line-height: 2; */
			height: 20px;
			text-align: center;
			line-height: 18px;
			border-radius: 10px;
			font-size: 12px;
			// color: #FFFFFF;
		}

		span:nth-child(1) {
			border: 1px solid #fff;
			// height: 20px;
			background: #cb2310;
			color: #FFFFFF;
			margin-right: 10px;
		}

		span:nth-child(2) {
			background: #fff;
			color: #cb2310;
		}
	}

	.card-icon {
		width: 330px;
		margin: 15px auto 0;
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		/* 四列等宽 */
		gap: 10px;

		.icon-item {
			margin: auto;
			display: flex;
			flex-direction: column;
			width: 50px;

			.custom-icon {
				color: #000;
			}
		}

		img {
			width: 30px;
			margin: 0 auto 10px;
		}
	}

	.flex_center {
		margin: 20px;
		height: 45px;
		color: #fff;
		background-image: url(../images/user/556699.jpg);
		background-size: 112% 132%;
		background-position: center;
		background-repeat: no-repeat;
	}

	.freez-card {
		color: #ffc945;
		font-size: 18px;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.fajia {
		margin-left: 10px;
		font-size: 11px;
		color: #fff;
	}
</style>